import { inject, Injectable } from '@angular/core';
import { distinctUntilChanged, Observable, Subject, switchMap } from 'rxjs';

import { TranslateService } from '@plugins/client/translate/services';
import { Maybe } from '@plugins/shared/types/helpers';

/** Provides the entity's translated name to external consumers. Used internally
 *  and provided within each instance of the `UserNameComponent` and `UserAvatarComponent`.
 * External consumers can then subsribe to `translatedName$` observable. */
@Injectable()
export class TranslatedNameService {
  private readonly translateService = inject(TranslateService);
  protected translatedName = new Subject<Observable<string>>();
  translatedName$ = this.translatedName.asObservable().pipe(
    switchMap((name) => name),
    distinctUntilChanged(),
  );

  updateTranslation(
    key: Maybe<string>,
    properties: Maybe<Record<string, string | number>>,
  ): void {
    if (!key || !properties) return;
    this.translatedName.next(this.translateService.get(key, properties));
  }
}
